import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qa-event-preview-popup h-flex h-height-100p h-flex-dir-column h-flex-space-between"
}
const _hoisted_2 = {
  key: 0,
  ref: "map",
  class: "h-width-100p b-global-map",
  style: {"height":"200px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_LeafletMap = _resolveComponent("LeafletMap")!

  return (!_ctx.forceHideMap)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.mapsApi_isGoogleMap)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.isMapLoading)
                ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
                    key: 0,
                    colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
                    isActive: _ctx.isMapLoading
                  }, null, 8, ["isActive"]))
                : _createCommentVNode("", true)
            ], 512))
          : (_ctx.mapsApi_isLeafletMap)
            ? (_openBlock(), _createBlock(_component_LeafletMap, {
                key: 1,
                latitude: _ctx.latitude,
                longitude: _ctx.longitude,
                class: "h-width-100p b-global-map"
              }, null, 8, ["latitude", "longitude"]))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}